import cloneDeep from 'lodash/cloneDeep';
import actionTypes from '../actions/action-types';

const initialState = {
  fields: {},
  attachments: {},
  title: '',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_CMS_TERMS_OF_USE_SUCCESS:
    case actionTypes.FETCH_CMS_PRIVACY_POLICY_SUCCESS: {
      return {
        fields: cloneDeep(action.response.fields),
        attachments: cloneDeep(action.response.attachments),
        title: action.response.title,
      };
    }
    case actionTypes.CLEAR_CMS_TERMS: {
      return initialState;
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/app/reducers/terms-management.reducer.js